export const isEmpty = (obj: any) => !obj || Object.keys(obj).length === 0;
